// Lazy-import firebase/functions so its module-load `fetch.bind(self)` call
// doesn't break Gatsby SSR build (Node 16 has no global fetch).
const callable = (name) => async (data) => {
  if (typeof window === "undefined") return null;
  const { getFunctions, httpsCallable } = await import("firebase/functions");
  const res = await httpsCallable(getFunctions(), name)(data);
  return res.data;
};

// Invoices
export const createInvoice = callable("createInvoice");
export const markInvoicePaid = callable("markInvoicePaid");

// Sales agent
export const draftColdEmail = callable("draftColdEmail");
export const createManualDraft = callable("createManualDraft");
export const discardColdEmailVariant = callable("discardColdEmailVariant");
export const approveMessage = callable("approveMessage");
export const rejectMessage = callable("rejectMessage");
export const markLeadWon = callable("markLeadWon");
export const archiveLead = callable("archiveLead");
export const archiveStaleLeads = callable("archiveStaleLeads");
export const dedupeExistingLeads = callable("dedupeExistingLeads");
export const salesAggregate = callable("salesAggregate");
export const suppressEmail = callable("suppressEmail");
export const triggerIngest = callable("triggerIngest");

// Academy e-learning
export const askMentor = callable("askMentor");

// Open positions / applicants
export const applyToOpening = callable("applyToOpening");

// Newsletter signup (public — no auth required)
export const subscribeNewsletter = callable("subscribeNewsletter");

// Slack invite request (public — no auth required)
export const requestSlackInvite = callable("requestSlackInvite");

// Gamification
export const awardXp = callable("awardXp");
export const verifyLab = callable("verifyLab");
export const weeklyDigest = callable("weeklyDigest");
export const awardManualBadge = callable("awardManualBadge");

// Sales reply (operator-composed) — wraps sendOne, writes outbound message doc.
export const sendReply = callable("sendReply");

// Outbound learning loop — operator cancel for an enrolled sequence.
export const cancelSequence = callable("cancelSequence");

export const setAvatar = callable("setAvatar");
export const addAvatarToLibrary = callable("addAvatarToLibrary");
export const clearAvatar = callable("clearAvatar");

// Live lab sessions
export const startLabSession = callable("startLabSession");
export const endLabSession = callable("endLabSession");
